import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { AlertService } from '../../_services/index';
import { StatusService } from '../../_services/status.service'
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';
import * as $ from 'jquery';

var COMP = environment.component.status;

interface Row {
  catid:number;
  scatid:number;
  qcatid:number;
  cat:string;
  cspan:number;
  scat:string;
  scspan:number;
  qcat:string;
  qcspan:number;
  nasiv:number;
  nasivspan:number;
  ssim:string;
  ssimspan:number;
  unit1:string;
  unit1span:number;
  ques:string;
  unit2:string;
  baseline:number;
  current:number;
  aspiration:number;
  change_16_17:number;
  changespan:number;
  percent_of_2030:number;
  percentspan:number;
  cat_class:string;
  scat_class:string;
}

@Component({
  selector: 'app-status-data',
  templateUrl: './status-data.component.html',
  styleUrls: ['./status-data.component.css']
})
export class StatusDataComponent implements OnInit, OnDestroy {

  subscription1:Subscription;
  subscription2:Subscription;
  rows_final: Array<Row>=[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private statusService: StatusService) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".status-click").addClass("header_active")

    this.subscription1 = this.statusService.prepareForStatusResult()
    .subscribe((data)=>{
      this.statusService.calculateStatusResult(data)
      .subscribe((data)=>{
        this.rows_final = data;
      });
    });
  }

empty_objects(objects_arrays){
  for (var j=0; j<objects_arrays.length; j++){
    var props = Object.getOwnPropertyNames(objects_arrays[j]);
    for (var i = 0; i < props.length; i++) {
      delete objects_arrays[j][props[i]];
    }
  }
}

ngOnDestroy() {
  this.rows_final = null;

  if(this.subscription1)
    this.subscription1.unsubscribe();
  if(this.subscription2)
    this.subscription2.unsubscribe();
}

  policyBtnClick(){
    this.router.navigateByUrl('/sdg/status')
  }
  quesBtnClick(){
    this.router.navigateByUrl('/sdg/status-quest')
  }
  dataBtnClick(){
    this.router.navigateByUrl('/sdg/status-data')
  }
  reportBtnClick(){
    this.router.navigateByUrl('/sdg/status-report')
  }
  get_percent_text(p){
    if(p==null)
      return p;
    if(p == '-Infinity' || Number.isNaN(parseFloat(p)))
      return 'Infinite Value';
    else
      return parseFloat(p).toFixed(1).toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/status-data/status-data.component.ts